module.exports = __webpack_public_path__ + "static/media/beerparrot.dd463a25.gif";